// extracted by mini-css-extract-plugin
export var quillEditor = "_ig-1";
export var variable = "_ig-0";